import React from 'react';
import {connect} from "react-redux";
import * as filesActions from "../../../actions/files";
import FileForm from "./FileForm";

class FileItem extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            editMode : false
        }
    }

    downloadFile = () =>{
        this.props.dispatch(filesActions.downloadFile(this.props.id,this.props.name));
    };

    handleDelete = () =>{
        this.props.dispatch(filesActions.deleteFile(this.props.id,this.props.fogId));
    };

    toggleForm = () =>{
        this.setState({editMode: !this.state.editMode});
    };

    render() {

        if(this.state.editMode) {
            return(<FileForm icon={this.props.icon} toggleForm={this.toggleForm} name={ this.props.name } id={this.props.id} fogId={this.props.fogId} file={this.props.file} successCallback={() => this.toggleForm()} />);
        } else {
            return (
                <tr className="file-item clickable">
                    <td onClick={this.downloadFile} ><i className={`fa ${this.props.icon}`} aria-hidden="true"></i></td>
                    <td onClick={this.downloadFile} ><span>{this.props.name}</span></td>
                    <td className="align-right">
                        <button onClick={this.handleDelete} type="button" icon="delete" className="btn btn-floating small"><i className="material-icons">delete</i></button>
                        <button onClick={this.toggleForm} type="button" icon="edit" className="btn btn-floating small file-item-edit-button"><i className="material-icons">edit</i></button>
                    </td>
                </tr>
            );
        }
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.files.loading,
        saving: state.files.saving,
        deleting: state.files.deleting,
        files: state.files.files,
    });
})(FileItem);


// WEBPACK FOOTER //
// ./src/components/fog/FilesUpload/FileItem.js